import { render, staticRenderFns } from "./logincopy.vue?vue&type=template&id=370bb9c3&scoped=true"
import script from "./logincopy.vue?vue&type=script&lang=js"
export * from "./logincopy.vue?vue&type=script&lang=js"
import style0 from "./logincopy.vue?vue&type=style&index=0&id=370bb9c3&prod&lang=scss&scoped=true"
import style1 from "./logincopy.vue?vue&type=style&index=1&id=370bb9c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bb9c3",
  null
  
)

export default component.exports